import { render, staticRenderFns } from "./ImportClientsModal.vue?vue&type=template&id=9dbc4204&scoped=true&"
import script from "./ImportClientsModal.vue?vue&type=script&lang=js&"
export * from "./ImportClientsModal.vue?vue&type=script&lang=js&"
import style0 from "./ImportClientsModal.vue?vue&type=style&index=0&id=9dbc4204&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dbc4204",
  null
  
)

export default component.exports